import { useEffect, useState } from 'react'
import { Table, Pagination, Form } from 'react-bootstrap'
import { myId } from '../Pages/ResultTable'
import { IoClose } from "react-icons/io5";
import PropTypes from 'prop-types';

const initDataTable = {
    actualPage: 1,
    totalPages: 1,
    data: [],
    rowsPerPage: 10,
  };



const TableCustomersBigQuery = ({ dataCustomersBigQuery,setShowTCBigQuery }) => {
    const [dataTable, setDataTable] = useState(initDataTable);
  //const [dataSearch, setDataSearch] = useState([]);

  useEffect(() => {
    const totalPages = Math.ceil(
      dataCustomersBigQuery?.length / dataTable.rowsPerPage
    );
    setDataTable({
      ...dataTable,
      totalPages,
      data: dataCustomersBigQuery.slice(0, dataTable.rowsPerPage),
    });
    //initDataSearch();
  }, []);

  useEffect(() => {
    console.log(
      "dataTable(Cambio en el Contenido a Renderizar):...",
      dataTable
    );
  }, [dataTable]);

  const handleChangeRowsPerPage = (e) => {
    console.log("e.target.value:...", e.target.value);
    const rowsPerPage = Number(e.target.value);
    const totalPages = Math.ceil(dataCustomersBigQuery?.length / rowsPerPage);
    const initReg = dataTable.actualPage * rowsPerPage - rowsPerPage;
    const endReg = dataTable.actualPage * rowsPerPage;
    setDataTable({
      ...dataTable,
      totalPages,
      rowsPerPage,
      data: dataCustomersBigQuery.slice(initReg, endReg),
    });
  };

  const handleClose = () => {
    console.log("handleClose...");
    setShowTCBigQuery(false);
  }

  return (
    <div className="">
      <div className="fs-3 m-2 d-flex  border bg-light rounded w-100">
        <div className="text-end w-50 ">
        Data Customers BigQuery
        </div>
        <div className="text-end w-50  pe-3 ">
          <span onClick={handleClose} className="btn btn-light fs-4">
        <IoClose/>
        </span>
        </div>
      </div>
      
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Customer Num</th>
            <th>Email</th>
            <th>Name</th>
            <th>Last Name</th>
          </tr>
        </thead>
        <tbody>
          {dataTable.data.map((customer) => (
            <tr key={myId()}>
                <td>{customer.id_crm}</td>
              <td>{customer.email}</td>
              <td>{customer.nombre_cliente}</td>
              <td>{customer.apellidos_cliente}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination className=" d-flex justify-content-center align-items-center w-100">
        <Pagination.First
          onClick={() => {
            setDataTable({
              ...dataTable,
              actualPage: 1,
              data: dataCustomersBigQuery.slice(0, dataTable.rowsPerPage),
            });
          }}
        />
        <Pagination.Prev
          onClick={() => {
            if (dataTable.actualPage === 1) return;
            setDataTable({
              ...dataTable,
              actualPage: dataTable.actualPage - 1,
              data: dataCustomersBigQuery.slice(
                (dataTable.actualPage - 2) * dataTable.rowsPerPage,
                (dataTable.actualPage - 1) * dataTable.rowsPerPage
              ),
            });
          }}
        />
        <Pagination.Item active>{dataTable.actualPage}</Pagination.Item>
        <Pagination.Ellipsis />
        <Pagination.Item>{dataTable.totalPages}</Pagination.Item>
        <Pagination.Next
          onClick={() => {
            if (dataTable.actualPage === dataTable.totalPages) return;
            setDataTable({
              ...dataTable,
              actualPage: dataTable.actualPage + 1,
              data: dataCustomersBigQuery.slice(
                dataTable.actualPage * dataTable.rowsPerPage,
                (dataTable.actualPage + 1) * dataTable.rowsPerPage
              ),
            });
          }}
        />
        <Pagination.Last
          onClick={() => {
            setDataTable({
              ...dataTable,
              actualPage: dataTable.totalPages,
              data: dataCustomersBigQuery.slice(
                (dataTable.totalPages - 1) * dataTable.rowsPerPage,
                dataTable.totalPages * dataTable.rowsPerPage
              ),
            });
          }}
        />

        <Form.Select
          style={{ width: "60px" }}
          className="m-1 p-1"
          name="rowsPerPage"
          onChange={handleChangeRowsPerPage}
          id=""
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
        </Form.Select>
      </Pagination>
    </div>
  )
}

TableCustomersBigQuery.propTypes = {
    dataCustomersBigQuery: PropTypes.array.isRequired,
};


export default TableCustomersBigQuery

/**
 * 
 * 
 * apellidos_cliente:"sanchez jacobo"
codigo_postal:"82000"
email:"monisj.196@gmail.com"
fecha_creacion:{value: '2024-02-25'}
fuente_creacion:"Digital"
id_crm:"999000576644"
nombre_cliente:"moni"
nombre_tienda:"E COMMERCE"
puntos_disponibles_actuales:0
telefono:null
tienda_creacion:"2203"
 * 
 * 
 * 
 */